import { render, staticRenderFns } from "./CdlSaudeResumo.vue?vue&type=template&id=04862d8c&scoped=true&"
import script from "./CdlSaudeResumo.vue?vue&type=script&lang=js&"
export * from "./CdlSaudeResumo.vue?vue&type=script&lang=js&"
import style0 from "./CdlSaudeResumo.vue?vue&type=style&index=0&id=04862d8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04862d8c",
  null
  
)

export default component.exports